module.exports = __webpack_public_path__ + "img/dog1.783e61da.png";